// src/components/Charts/ThroughputChart.jsx
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const ThroughputChart = ({ onClick }) => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: '2023',
        data: [175050, 165420, 179900, 174680, 181740, 185430, 188000, 192500, 195300, 198800, 202400, 205100],
        backgroundColor: 'rgba(77, 166, 255, 0.1)',
        borderColor: '#4da6ff',
        borderWidth: 3,
        fill: true,
        tension: 0.4
      },
      {
        label: '2022',
        data: [155820, 148500, 162300, 158900, 165200, 168500, 170800, 175200, 178500, 182100, 185400, 188200],
        backgroundColor: 'rgba(100, 100, 100, 0.05)',
        borderColor: '#aaa',
        borderWidth: 2,
        borderDash: [5, 5],
        fill: false,
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    onClick: (evt, elements) => {
      if (elements.length > 0 && onClick) {
        onClick();
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default ThroughputChart;